import api from './api'
import type { CompanySettings, UpdateCompanySettingsRequest, LeaveType, CreateLeaveTypeRequest, UpdateLeaveTypeRequest, NotificationSettings, PayrollSettings } from '@/types/settings.types'
import type { ApiResponse } from '@/types/api.types'

export const settingsService = {
  async getCompanySettings(): Promise<ApiResponse<CompanySettings>> {
    const response = await api.get('/settings/company')
    return response.data
  },

  async updateCompanySettings(request: UpdateCompanySettingsRequest): Promise<ApiResponse<CompanySettings>> {
    const response = await api.put('/settings/company', request)
    return response.data
  },

  async uploadCompanyLogo(file: File): Promise<ApiResponse<CompanySettings>> {
    const formData = new FormData()
    formData.append('file', file)
    const response = await api.post('/settings/company/logo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    return response.data
  },

  async getLeaveTypes(): Promise<ApiResponse<LeaveType[]>> {
    const response = await api.get('/settings/leave-types')
    return response.data
  },

  async createLeaveType(request: CreateLeaveTypeRequest): Promise<ApiResponse<LeaveType>> {
    const response = await api.post('/settings/leave-types', request)
    return response.data
  },

  async updateLeaveType(id: string, request: UpdateLeaveTypeRequest): Promise<ApiResponse<LeaveType>> {
    const response = await api.put(`/settings/leave-types/${id}`, request)
    return response.data
  },

  async deleteLeaveType(id: string): Promise<ApiResponse<any>> {
    const response = await api.delete(`/settings/leave-types/${id}`)
    return response.data
  },

  // ---- Resmi tatiller ----
  async getHolidays(): Promise<any> {
    const response = await api.get('/settings/holidays')
    return response.data
  },
  async createHoliday(payload: { date: string; name: string; recurringYearly?: boolean }): Promise<any> {
    const response = await api.post('/settings/holidays', payload)
    return response.data
  },
  async deleteHoliday(id: string): Promise<any> {
    const response = await api.delete(`/settings/holidays/${id}`)
    return response.data
  },

  async getNotificationSettings(): Promise<ApiResponse<NotificationSettings>> {
    const response = await api.get('/settings/notifications')
    return response.data
  },

  async updateNotificationSettings(settings: Partial<NotificationSettings>): Promise<ApiResponse<NotificationSettings>> {
    const response = await api.put('/settings/notifications', settings)
    return response.data
  },

  async getPayrollSettings(): Promise<ApiResponse<PayrollSettings>> {
    const response = await api.get('/settings/payroll')
    return response.data
  },

  async updatePayrollSettings(settings: Partial<PayrollSettings>): Promise<ApiResponse<PayrollSettings>> {
    const response = await api.put('/settings/payroll', settings)
    return response.data
  }
}
